/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Onboarding_Date_Of_Birth_MessageInputs */

const en_us2_onboarding_date_of_birth_message = /** @type {(inputs: Onboarding_Date_Of_Birth_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I was born on ${i?.value}`)
};

const pt_br2_onboarding_date_of_birth_message = /** @type {(inputs: Onboarding_Date_Of_Birth_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nasci em ${i?.value}`)
};

const es_419_onboarding_date_of_birth_message = /** @type {(inputs: Onboarding_Date_Of_Birth_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nací el ${i?.value}`)
};

const pt_pt2_onboarding_date_of_birth_message = /** @type {(inputs: Onboarding_Date_Of_Birth_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nasci a ${i?.value}`)
};

const fr_fr2_onboarding_date_of_birth_message = /** @type {(inputs: Onboarding_Date_Of_Birth_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ma date de naissance : ${i?.value}`)
};

const de_de2_onboarding_date_of_birth_message = /** @type {(inputs: Onboarding_Date_Of_Birth_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich bin am ${i?.value} geboren`)
};

const it_it2_onboarding_date_of_birth_message = /** @type {(inputs: Onboarding_Date_Of_Birth_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La mia data di nascita è ${i?.value}`)
};

/**
* | output |
* | --- |
* | "I was born on {value}" |
*
* @param {Onboarding_Date_Of_Birth_MessageInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_date_of_birth_message = /** @type {((inputs: Onboarding_Date_Of_Birth_MessageInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Date_Of_Birth_MessageInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_date_of_birth_message(inputs)
	if (locale === "es-419") return es_419_onboarding_date_of_birth_message(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_date_of_birth_message(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_date_of_birth_message(inputs)
	if (locale === "de-DE") return de_de2_onboarding_date_of_birth_message(inputs)
	if (locale === "it-IT") return it_it2_onboarding_date_of_birth_message(inputs)
	return en_us2_onboarding_date_of_birth_message(inputs)
});
export { onboarding_date_of_birth_message as "onboarding.date_of_birth.message" }